define("analytics-resources/utils/charts/area-spline-chart-options", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getGradientDefinition = getGradientDefinition;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function getGradientDefinition(color) {
    return {
      // eslint-disable-next-line @latermedia/later-linting/avoid-numerals-in-name
      gradient0: {
        tagName: 'linearGradient',
        children: [{
          tagName: 'stop',
          // @ts-expect-error: Highcharts types should have offset
          // see https://www.highcharts.com/docs/chart-design-and-style/gradients-shadows-and-patterns
          offset: 0
        }, {
          tagName: 'stop',
          // @ts-expect-error: Highcharts types should have offset
          // see https://www.highcharts.com/docs/chart-design-and-style/gradients-shadows-and-patterns
          offset: 1
        }],
        attributes: {
          id: color ? `cCH--chartGradient__${color}` : 'cCH--chartGradient',
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        }
      }
    };
  }
});